/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Send_Idle_AriaInputs */

const en_form_send_idle_aria = /** @type {(inputs: Form_Send_Idle_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send message`)
};

const ar_form_send_idle_aria = /** @type {(inputs: Form_Send_Idle_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إرسال الرسالة`)
};

const bn_form_send_idle_aria = /** @type {(inputs: Form_Send_Idle_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বার্তা পাঠান`)
};

const de_form_send_idle_aria = /** @type {(inputs: Form_Send_Idle_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht senden`)
};

const es_form_send_idle_aria = /** @type {(inputs: Form_Send_Idle_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar mensaje`)
};

const fr_form_send_idle_aria = /** @type {(inputs: Form_Send_Idle_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer un message`)
};

const pt_form_send_idle_aria = /** @type {(inputs: Form_Send_Idle_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar mensagem`)
};

const zh_form_send_idle_aria = /** @type {(inputs: Form_Send_Idle_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送消息`)
};

const tr_form_send_idle_aria = /** @type {(inputs: Form_Send_Idle_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesaj gönder`)
};

const ru_form_send_idle_aria = /** @type {(inputs: Form_Send_Idle_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправить сообщение`)
};

const pl_form_send_idle_aria = /** @type {(inputs: Form_Send_Idle_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyślij wiadomość`)
};

/**
* | output |
* | --- |
* | "Send message" |
*
* @param {Form_Send_Idle_AriaInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const form_send_idle_aria = /** @type {((inputs?: Form_Send_Idle_AriaInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Send_Idle_AriaInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_form_send_idle_aria(inputs)
	if (locale === "bn") return bn_form_send_idle_aria(inputs)
	if (locale === "de") return de_form_send_idle_aria(inputs)
	if (locale === "es") return es_form_send_idle_aria(inputs)
	if (locale === "fr") return fr_form_send_idle_aria(inputs)
	if (locale === "pt") return pt_form_send_idle_aria(inputs)
	if (locale === "zh") return zh_form_send_idle_aria(inputs)
	if (locale === "tr") return tr_form_send_idle_aria(inputs)
	if (locale === "ru") return ru_form_send_idle_aria(inputs)
	if (locale === "pl") return pl_form_send_idle_aria(inputs)
	return en_form_send_idle_aria(inputs)
});